import { OnInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ToastService } from 'src/app/shared/components/toast/toast.service';

@Component({
  selector: 'app-verification-password',
  templateUrl: './verification-password.component.html',
  styleUrls: ['./verification-password.component.scss'],
})
export class VerificationPasswordComponent implements OnInit {
  showError: boolean = false;
  errorMessage: string = '';
  isLoader = false;
  emailInvalid!: boolean;
  user: any;
  message!: string;
  isMsgSent = false;

  isPressedConfirm: any;
  newPassword: any;
  confirmPwd: any;
  username: any;
  _isCheckedToken = false;
  launchedRequest: any = false;
  isLoaderChange = false;
  constructor(
    public _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _cookieService: CookieService,
    private _toastService: ToastService,
    private _router: Router
  ) {}
  pressConfirmPwd(password: any, confirm: any) {
    this.showError = false;
    this.errorMessage = '';
    if (password) {
      if (password == confirm) {
        this.isPressedConfirm = true;
      } else {
        this.showError = true;
        this.errorMessage = 'Le mot de passe ne correspond pas';
        this.isPressedConfirm = false;
      }
    }
  }
  ngOnInit() {
    this.checkToken();
  }

  changePassword(_password: string) {
    this.isLoaderChange = true;
    this.showError = false;
    this.message = '';
    this._authService
      .changePasword({ password: _password, username: this.username })
      .subscribe(
        (response: any) => {
          this.isLoaderChange = false;
          if (response.code === 202) {
            this._cookieService.delete('user_token');
            this.showSuccess('Votre mot de passe a été changé');
            void this._router.navigate(['/connexion']);
          }
        },
        (err) => {
          this.isLoaderChange = false;
          this.showError = true;
          this.errorMessage = 'Format de mot de passe incorrect';
        }
      );
  }

  showSuccess(msg: any) {
    this._toastService.show(msg, {
      classname: 'bg-success text-light',
      delay: 5000,
    });
  }

  showDanger(dangerTpl: any) {
    this._toastService.show(dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 5000,
    });
  }

  checkToken() {
    this._isCheckedToken = false;
    this.showError = false;
    this.errorMessage = '';
    this.isLoader = false;
    this._activatedRoute.queryParams.subscribe((params) => {
      if (params['token_pwd']) {
        this._authService
          .checkTokenPassword({ token: params['token_pwd'] })
          .subscribe(
            (response: any) => {
              if (response['code'] == 202) {
                this._cookieService.set(
                  'user_token',
                  JSON.stringify(response['data'])
                );
                this.username = JSON.parse(
                  this._cookieService.get('user_token')
                )[0].usermail;

                this._isCheckedToken = true;
              }
              this.isLoader = true;
            },
            (err: any) => {
              this.showError = true;
              this.errorMessage =
                "L'Url est incorrecte pour réinitialiser votre mot de passe: " +
                err;
              this.isLoader = true;
              this._isCheckedToken = false;
            }
          );
        this._isCheckedToken = true;
      }
    });
  }

  sendResetPassword(user: any, isMobile: boolean, isInvalid?: any) {}
}
